module.exports = __webpack_public_path__ + "img/tool-just8899.72f07b9.webp";